module.exports = __webpack_public_path__ + "img/welcome.51a631f4.png";